import { useQuery } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import { getCurrentAccount } from '../api-query/customer'

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

async function getDashboardData(session: any) {
    if(!session?.idToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const { siteId, timezone, providerId, hasUsageData, hasTou } = getCurrentAccount();
    if(!siteId) {
        throw new Error('Loading...')
    }
    if(hasUsageData===false) {
        return { hasUsageData }
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/dashboard/data`,
        {
            method: 'POST',
            body: JSON.stringify({ siteId, timezone, providerId, hasTou }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    return (await res.json())
}

export const useGetDashboardData = (session: any) => {
    const { 
        refetch,
        isFetching,
        isPending: dashboardPending, 
        error: errorDashboardData, 
        data: dashboardData } = useQuery({
            queryKey: ['DashboardData'], // key must be unique
            queryFn: ()=>getDashboardData(session),
            staleTime: (60000 * 2)
    })
    return { refetch, isFetching, dashboardPending, errorDashboardData, dashboardData }
};


